
import {useEffect} from 'react';

type CoordsCallback = (
	coords: {
		lat: number,
		lng: number,
	},
	source: 'GPS' | 'IP',
) => void

const geoTarget = 'https://ipinfo.io/?token=9d1df99dcae609';
const geoPattern = /^(-?\d+\.\d+),(-?\d+\.\d+)$/;

type GeoData = {
	ip: string
	hostname: string
	city: string
	region: string
	country: string
	loc: string
	postal: string
	timezone: string
};

export const useUserCoords = (cb: CoordsCallback) => {
	useEffect(() => {
		navigator.geolocation.getCurrentPosition(

			// If we're able to get coords from browser API, great!
			(position) => {
				cb({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				}, 'GPS');
			},

			// If we fail, do GeoIP lookup and parse
			async () => {
				const result = await fetch(geoTarget);
				const obj: GeoData = await result.json();

				if (!obj.loc) {
					return;
				} else if (!geoPattern.test(obj.loc)) {
					return;
				}

				const parts = obj.loc.split(',');
				if (parts.length !== 2) {
					return;
				}

				const coords = {
					lat: Number(parts[0]),
					lng: Number(parts[1]),
				};

				cb(coords, 'IP');
			},
		);
	}, []);
};
